import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=5c11dddc&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports